import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import { FormBuilder, Validators, FormGroup, FormControl } from '@angular/forms';
import {AuthenticationService} from "../../shared/services/authentication.service";
import {Loader, LoaderService} from "../../core/loader/loader.service";
import {LoginModel} from "./login.model";


@Component({
    templateUrl: 'login.component.html'
})

export class LoginComponent implements OnInit {
    returnUrl: string;
    submitted: boolean = false;

    loginForm: FormGroup;
    username: FormControl = new FormControl("",Validators.required);
    password: FormControl = new FormControl("",Validators.required);

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private authService: AuthenticationService,
        private loaderService: LoaderService,
        fb: FormBuilder) {

        // create form
        this.loginForm = fb.group({
            'username': this.username,
            'password': this.password
        });
    }

    ngOnInit() {
        this.authService.logout();

        // get return url from route parameters or default to '/'
        this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/';

    }

    login(model: any, isValid: boolean) {
        if (isValid) {
            this.loaderService.setStatus(new Loader(true, 'login', 'loader.login'));

            this.submitted = true;
            let promise = this.authService.login(
                new LoginModel(null, model.username, model.username, model.username, model.password)
            );

            promise.then((data) => {
                console.log('success promise');
                this.submitted = false;
                this.router.navigate(["/dashboards"]);
                this.loaderService.setStatus(new Loader(false, 'login',));
            }).catch((data) => {
                console.log('reject');
                console.log(data);
                this.submitted = false;
                this.loaderService.setStatus(new Loader(false, 'login',));
                data.object.errors.forEach((object, key) => {
                    this.loginForm.controls[object].setErrors({'incorrect': true})
                });
            })
        }
    }
}



// WEBPACK FOOTER //
// /code/frontend/src/app/auth/login/login.component.ts